import { gql, useQuery } from '@apollo/client';
import { Medication, Prescription } from '../../__generated__/graphql';
import { useEffect, useState } from 'react';
import { useTimezones } from '../../Common/hooks/useTimezones';
import { pusherSubscribeObject } from '../../Common/utils/pusher';
import { isDoctorPortal } from '../../Common/utils/isDoctorPortal';

export const queryGetPatientPrescriptions = gql`
 query getPrescriptions($customerID: String) {
    getPrescriptions(customerID: $customerID) {
      customerID
      __typename
      prescriptions {
        id
        consultID
        instructions
        pbs
        fufilled
        erxEligible
        erxError
        erxCeasePending
        erxCeased
        repeatsAvailable
        dispensedDate
        erxSent
        doctor
        authorised
        doctorNotes
        tgaReason
        brandSubstitutionNotAllowed
        createdAt
        deliveryMethod
        customerID
        active
        erxError
        notified
        regulation24
        repeatInterval
        doctorNotes
        version
        erxCreated
        qty
        medication {
          id
          name
          prescribeName
          routeOfAdministration
          strength
          form
          genericName
          image
        }
        repeats
        erxToken
        isSubscribed
        subscriptionPaused
        subscriptionDeliveryMethod
      }
    }
  }
`;

export const usePatientPrescriptions = (customerID: string) => {
  const { data, loading, refetch } = useQuery(queryGetPatientPrescriptions, {
    variables: {
      customerID,
    },
    skip: !customerID,
  });

  const { convertUTCDateToUserISO } = useTimezones();

  const [openPrescription, setOpenPrescription] = useState(false);

  const newPrescription = () => setOpenPrescription(true);

  useEffect(() => {
    const { unsubscribe } = pusherSubscribeObject(customerID, 'prescriptions', () => refetch());

    return () => {
      unsubscribe();
    };
  }, [customerID]);

  return {
    loading,
    prescriptions: ([...(data?.getPrescriptions?.prescriptions ?? [])]
      ?.filter((a) => (isDoctorPortal() ? true : a?.active))
      ?.sort((a: Prescription, b: Prescription): number => {
        const aDate = convertUTCDateToUserISO(b?.createdAt);
        const bDate = convertUTCDateToUserISO(a?.createdAt);

        return aDate?.diff(bDate) ?? 0;
      }) ?? []) as Prescription[],
    openPrescription,
    setOpenPrescription,
    newPrescription,
  };
};
